import { UnitConversionService } from '@/lib/services/unitConversions';

const EarthRadius = 6378137;
const OriginShift = 2 * Math.PI * EarthRadius / 2;

//https://gist.github.com/nagasudhirpulla/9b5a192ccaca3c5992e5d4af0d1e6dc4

//Converts given lat/lon in WGS84 Datum to XY in Spherical Mercator EPSG:900913
export function latLonToMeters(lat, lon) {
  var p = {};
  p.x = lon * OriginShift / 180;
  p.y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
  p.y = p.y * OriginShift / 180;
  return p;
};

//Converts XY point from (Spherical) Web Mercator EPSG:3785 (unofficially EPSG:900913) to lat/lon in WGS84 Datum
export function metersToLatLon(m) {
  var ll = {};
  ll.x = (m.x / OriginShift) * 180;
  ll.y = (m.y / OriginShift) * 180;
  ll.y = 180 / Math.PI * (2 * Math.atan(Math.exp(ll.y * Math.PI / 180)) - Math.PI / 2);
  return ll;
};

export function calculateArea(gpsPoints, unit) {
  if (gpsPoints.length <= 1) return 0; //zero and one point has 0 area

  let mappedPoints = gpsPoints.map(p => latLonToMeters(p[0], p[1]));
  mappedPoints.push(mappedPoints[0]); //append first point at end

  let sum1 = 0;
  let sum2 = 0;
  for (let i = 0; i < mappedPoints.length - 1; i++) {
    //https://www.wikihow.com/Calculate-the-Area-of-a-Polygon
    sum1 += mappedPoints[i].x * mappedPoints[i + 1].y;
    sum2 += mappedPoints[i].y * mappedPoints[i + 1].x;
  }

  let areaSqMetres = (Math.abs(sum1 - sum2)) / 2.0;

  return UnitConversionService.areaFromM2(areaSqMetres, unit);
}



// WEBPACK FOOTER //
// ./src/lib/services/coordinates.js